import React from 'react'
import ReactApexChart from "react-apexcharts"

export default function RequestLineChart(props) {
  let state = {
    series: [{
      name: "Quantidade:",
      data: props.data
    }],
    options: {
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      title: {
        text: props.title,
        align: 'left'
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5
        },
      },
      theme: {
        monochrome: {
          enabled: true,
          color: '#524ec6',
          shadeTo: 'light',
          shadeIntensity: 0.65
        }
      },
      xaxis: {
        categories: props.categories,
      }
    },
  };
  return (
    <>
      <ReactApexChart
        className={props.className}
        options={state.options}
        series={state.series}
        type={props.type}
        height={props.height}
        width={props.width}
      />
    </>
  )
}